var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfulence = function SvgConfulence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confulence_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#confulence_svg__b)",
    d: "M.873 18.057q-.389.612-.762 1.233a.766.766 0 0 0 .254 1.052l4.966 3.047a.764.764 0 0 0 1.05-.254q.35-.625.725-1.234c1.958-3.227 3.951-2.865 7.503-1.16l4.93 2.32a.77.77 0 0 0 1.014-.362l2.357-5.33c.18-.364 0-.835-.363-1.017a155 155 0 0 1-4.929-2.357c-6.705-3.229-12.396-3.01-16.745 4.062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#confulence_svg__c)",
    d: "M23.127 5.943q.387-.612.761-1.233a.765.765 0 0 0-.254-1.052L18.67.611a.764.764 0 0 0-1.051.255q-.349.624-.725 1.233c-1.958 3.228-3.95 2.865-7.503 1.16L4.46.939a.77.77 0 0 0-1.014.362L1.09 6.631c-.181.364 0 .836.363 1.017a154 154 0 0 1 4.928 2.357c6.706 3.193 12.397 3.01 16.745-4.062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "confulence_svg__b",
    x1: 22.791,
    x2: 7.792,
    y1: 24.967,
    y2: 16.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confulence_svg__c",
    x1: 1.209,
    x2: 16.207,
    y1: -0.977,
    y2: 7.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "confulence_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgConfulence;